var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "06_\u5E93\u623F\u53D1\u836F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.07,8v4h-24V8h24m2-4h-28a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2h28a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.15,60H16a4,4,0,0,1-4-4V24a4,4,0,0,1,4-4H48a4,4,0,0,1,4,4V43.89a2,2,0,0,1-4,0V24H16V56H38.15a2,2,0,0,1,0,4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.06,37.84H34V33.7a1.85,1.85,0,0,0-1.85-1.85H31.9a1.85,1.85,0,0,0-1.85,1.85v4.14H26a1.87,1.87,0,0,0-1.86,1.86V40A1.86,1.86,0,0,0,26,41.84h4.06V46a1.86,1.86,0,0,0,1.85,1.86h.24A1.86,1.86,0,0,0,34,46V41.84h4.07A1.85,1.85,0,0,0,39.91,40V39.7A1.86,1.86,0,0,0,38.06,37.84Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54,53.66l-4.89-5a.71.71,0,0,0-1.23.49V52H42a2,2,0,0,0,0,4h5.88v3a.85.85,0,0,0,1.37.6L54,54.75A.78.78,0,0,0,54,53.66Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.61b7c490.svg";
export { ForwardRef as ReactComponent };